import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skip } from 'rxjs/operators';

import { Linha } from 'src/app/models/api/comercial/linha';
import { ApiLinhaService } from 'src/app/services/api/comercial/api-linha-service';
import { IPaginator } from 'src/app/ui/paginator/paginator.component';

@Component({
  selector: 'c-commercial-line',
  templateUrl: './line.component.html',
  styleUrls: ['./line.component.scss']
})
export class CommercialLineComponent implements OnInit {
  lineData: LineEditable[];
  linePaginatedData: LineEditable[];
  lineFilteredData: LineEditable[];
  columns: string[] = ['name', 'active', 'actions'];
  form: FormGroup;
  paginator$ = new BehaviorSubject<IPaginator>({
    isLastPage: false,
    page: 1,
    pageLength: 25,
    total: 0
  });
  search$ = new BehaviorSubject('');
  constructor(
    private apiLinha: ApiLinhaService,
    private fb: FormBuilder,
  ) {
    this.createForm();
    this.listenPaginator();
    this.listenSearch();
  }

  ngOnInit() {
    this.loadLineData();
  }

  createForm() {
    this.form = this.fb.group({
      descricao: [null],
      ativo: [null]
    });
  }

  loadLineData() {
    this.apiLinha.getAllAtivosInativos().subscribe(res => {
      this.lineData = res.data as LineEditable[];
      this.paginate(this.paginator$.value);
    });
  }

  edit(data: LineEditable) {
    data.newDescription = data.descricao;
    data.isEditActive = true;
  }

  cancelEdit(data: LineEditable) {
    data.newDescription = data.descricao;
    data.isEditActive = false;
  }

  async save(data: LineEditable) {
    if (!data) {
      const line: LineEditable = this.form.value;
      line.descricao = line.descricao;
      line.ativo = true;

      await this.apiLinha.insert(line).toPromise();
      this.form.reset();
      this.loadLineData();
    } else {
      const description = data.newDescription;

      await this.apiLinha.update({
        id: data.id, descricao: description, ativo: data.ativo
      }).toPromise();
      data.descricao = description;
      data.isEditActive = false;
    }
  }

  async changeEnableDisable(data: LineEditable) {
    try {
      await this.apiLinha.delete(data.id).toPromise();
    } catch {
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    }
  }

  private listenSearch() {
    this.search$.pipe(skip(1), debounceTime(800)).subscribe((res) => {
      if (res) {
        this.lineFilteredData = this.lineData.filter(elem => {
          const regex = new RegExp(res.normalize('NFD').replace(/[\u0300-\u036f]/g, ''), 'i');
          const line = regex.test(elem.descricao.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
          return line;
        });
      } else {
        this.lineFilteredData = undefined;
      }
    });
  }

  private listenPaginator() {
    this.paginator$.subscribe(res => {
      this.paginate(res);
    });
  }

  private paginate(data: IPaginator) {
    if (this.lineData) {
      const startAt = (data.page - 1) * data.pageLength;
      this.linePaginatedData = this.lineData.slice(startAt, startAt + data.pageLength);
    }
  }

  get canCreate() {
    return this.descricao.value;
  }
  get descricao() { return this.form.get('descricao'); }
}

interface LineEditable extends Linha {
  isEditActive: boolean;
  newDescription: string;
}